export const RoleMenu: any = {
  repower_view: [
    '/repower-Predictor',
    '/dashboard',
    '/repower-screen-2',
    '/repower-screen-3',
    '/repower-screen-3-price-dynamics',
    '/repower-screen-3-price-dynamics-line',
    '/',
    '/catastrophic-failure',
    '/mine-risk-donut',
    '/disclaimer',
    '/opportunity-overview',
    '/europe-impact-report',
    '/cspec-bridge',
    '/sales-overview',
    '/customer-overview',
    '/cspec-sales-bridge',
    '/financial-metrics',
    '/chat',
    '/tco-score',
    '/repower-donut-and-filter-chart',
    '/repower-second-horizontal-bar-chart',
  ]
};
